export default "__VITE_ASSET__B$Ab2Hrr__"